/**
 * データベース初期化メソッド
 */

// キニッタ！共通メソッド
import * as GVar from '@/components/00/Var00';                  // 共通変数
import * as Memotta from '@/components/00/Common00';            // 共通メソッド
import * as TableDef from '@/components/00/db/TableDef';        // テーブル定義
import * as Mst001 from '@/components/00/db/Mst001';            // MAT001
import * as Mst002 from '@/components/00/db/Mst002';            // MST002

/**
 * データベース初期化
 */
export const initializeDatabase = async () =>
{
        if ( Memotta.isDebugEnabled() ) {console.log("dbBase initializeDatabase()");}
        try
        {           
                const ret = await GVar.sqlite.checkConnectionsConsistency();
                const isConn = (await GVar.sqlite!.isConnection("ms", false)).result;
                if (ret.result && isConn) {
                GVar.setDb(await GVar.sqlite!.retrieveConnection("ms", false));
                } else {
                GVar.setDb(await GVar.sqlite!.createConnection("ms", false, "non-encription", 1, false));
                }
                await GVar.db.open();
                if ( Memotta.isDebugEnabled() ) {console.log("データーベースの初期化が終了しました。");}
        }
        catch(e)
        {
                console.log(GVar.sqliteErrorMsg+"データーベースの初期化に失敗しました。："+`${e}`);
                return;
        }
        try
        {
                let result: any;
                // mst001存在＆バージョンNo.チェック
                result = await GVar.db!.query("select count(*) as cnt from sqlite_master where type = 'table' and name = 'mst001'");
                if ( result.values![0].cnt == 0 )
                {
                        // テーブルが存在しないので作成する
                        Mst001.create();
                }
                else
                {
                        // テーブルが存在するのでバージョンNo.をチェック
                        result = await GVar.db.query("select ver_no from mst001 where lower(tbl_id) = 'mst001'");
                        if ( result.values!.length == 1 )
                        {
                                console.log("mst001 バージョンNo.チェック インストール済みバージョンNo.="+result.values![0].ver_no+", 新バージョンNo.="+TableDef.mstTables["mst001"]["ver"]);
                        }
                        else
                        {
                                console.log("mst001 バージョンNo.チェック インストール済みバージョンNo.=なし, 新バージョンNo.="+TableDef.mstTables["mst001"]["ver"]);
                        }
                        
                        if ( result.values!.length == 0 || result.values![0].ver_no != TableDef.mstTables["mst001"]["ver"]  )
                        {
                                // バージョンNo.が違うのでテーブルを再作成する
                                result = await GVar.db.run("DROP TABLE IF EXISTS mst001");
                                Mst001.create();
                        }
                }
        }
        catch(e)
        {
                console.log(GVar.sqliteErrorMsg+"mst001のバージョンチェックに失敗しました。："+`${e}`);
                return;
        }
        try
        {
                // Mst001以外の全テーブルのバージョンNo.が変わっていないかチェックする
                for ( const tableId in  TableDef.mstTables )
                {
                        if ( tableId == "mst001" ) continue;
                        await checkTableVersionNo(tableId, TableDef.mstTables[tableId]["ver"]);
                }
                if ( Memotta.isDebugEnabled() ) {console.log("全テーブルのバージョンチェックが終了しました。");}
        }
        catch(e)
        {
                console.log(GVar.sqliteErrorMsg+"mst001以外のバージョンチェックに失敗しました。："+`${e}`);
        }   
}

/**
 * インストール済みのテーブルバージョンNo.とアプリ内のテーブルバージョンNo.を比較し、
 * バージョンNo.が等しくなければテーブルを再作成する
 *
 * @param tableId ターブル名
 * @param verno バージョンNo.
 */
export const checkTableVersionNo = async (tableId: string, verno: string) =>
{
        if ( Memotta.isDebugEnabled() ) { console.log("dbBase checkTableVersionNo() "+tableId); }
        try
        {
                let result: any;
                result = await GVar.db!.query("select count(*) as cnt from sqlite_master where type = 'table' and name = ?",[tableId]);
                if ( result.values![0].cnt == 0 )
                {
                        // テーブルが存在しないので作成する
                        await TableDef.mstTables[tableId]["func"]();
                }
                else
                {
                        // テーブルが存在するのでバージョンNo.をチェック
                        result = await GVar.db!.query("select ver_no from mst001 where tbl_id = ?",[tableId]);
                        if ( result.values!.length > 0 )
                        {
                                if ( Memotta.isDebugEnabled() ) { console.log(tableId+" バージョンNo.チェック インストール済みバージョンNo.="+result.values![0].ver_no+", 新バージョンNo.="+verno); }
                                if ( result.values![0].ver_no != verno )
                                {
                                        // バージョンNo.が違うのでテーブルを再作成する
                                        result = await GVar.db!.run("DROP TABLE IF EXISTS "+ tableId);
                                        await TableDef.mstTables[tableId]["func"]();
                                }
                        }
                }
        }
        catch(e)
        {
                console.log(GVar.sqliteErrorMsg+tableId+"テーブルのバージョンチェックに失敗しました。："+`${e}`);
        }

        // ログイン情報ロード
        if ( tableId == "mst002" )
        {
                if ( Memotta.isDebugEnabled() ) { console.log(tableId+" ログイン情報をロード"); }
                // ログイン情報をロードする
                Mst002.getLoginInfo(GVar.sysCd, GVar.tmpltCd);                
        }
}


/*
// 動作確認OK
export const initDb = async () =>
{
        if ( Memotta.isDebugEnabled() ) {console.log("initDb()");}
        try
        {
                // データーベース初期化
                const sqlite = new SQLiteConnection(CapacitorSQLite);
                const db = await sqlite.createConnection( "ms", false, "non-encription", 1, false);
                // データーベースオープン
                await db.open();
                if ( Memotta.isDebugEnabled() ) {console.log("データーベースの初期化が終了しました。");}
                database.value = db;

                let result;
                // mst001存在＆バージョンNo.チェック
                result = await (database as any).value?.query("select count(*) as cnt from sqlite_master where type = 'table' and name = 'mst001'");
                if ( result.rows.item(0).cnt == 0 )
                {
                        // テーブルが存在しないので作成する
                        create_mst001();
                }
                else
                {
                        // テーブルが存在するのでバージョンNo.をチェック
                        result = await (database as any).value?.query("select ver_no from mst001 where tbl_id = 'mst001'");
                        console.log("mst001 バージョンNo.チェック インストール済みバージョンNo.="+result.rows.item(0).ver_no+", 新バージョンNo.="+mstTables["mst001"]["ver"]);
                        if ( result.rows.item(0).ver_no != mstTables["mst001"]["ver"]  )
                        {
                                // バージョンNo.が違うのでテーブルを再作成する
                                result = await (database as any).value?.run("DROP TABLE IF EXISTS mst001");
                                create_mst001();
                        }
                }
        }
        catch(e)
        {
                console.log("Error: データーベースの初期化に失敗しました。");
        }
}
*/